module.exports = __webpack_public_path__ + "img/12.665b7de4.jpg";